import { Money } from "@hubrise/react-components"
import _ from "lodash"

import { ICatalog, IOption, IOptionList, IProduct, ISku } from "shared/hubrise/models"
import { updatedCatalog } from "shared/hubrise/utils/Catalog"
import * as PriceOverrides from "shared/hubrise/utils/PriceOverrides"

export const bulkUpdatePrices = <ItemType extends ISku | IOption>(
  topLevelField: ItemType extends ISku ? "products" : "optionLists",
  catalog: ICatalog,
  sourceVariantRef: string | null,
  targetVariantRef: string | null,
  skipAlreadySetPrices: boolean,
  calculateTargetPrice: (sourcePrice: Money) => Money,
  selectItem?: (item: ItemType) => boolean,
) => {
  const topLevelItems = _.cloneDeep(catalog.data[topLevelField])
  topLevelItems.forEach((topLevelItem) => {
    const items = (
      topLevelField === "products" ? (topLevelItem as IProduct).skus : (topLevelItem as IOptionList).options
    ) as Array<ItemType>
    items
      .filter((item) => (selectItem ? selectItem(item) : true))
      .forEach((item) => {
        const sourcePrice =
          sourceVariantRef === null
            ? item.price
            : (PriceOverrides.variantPrice(item.priceOverrides, sourceVariantRef) ?? item.price)

        const prevTargetPrice =
          targetVariantRef === null ? item.price : PriceOverrides.variantPrice(item.priceOverrides, targetVariantRef)
        if (skipAlreadySetPrices && prevTargetPrice) return

        const targetPrice = calculateTargetPrice(sourcePrice)
        if (targetVariantRef === null) {
          item.price = targetPrice
        } else {
          item.priceOverrides = PriceOverrides.setVariantPrice(item.priceOverrides, targetVariantRef, targetPrice)
        }
      })
  })
  return updatedCatalog(catalog, { [topLevelField]: topLevelItems })
}

export const clearAllPrices = (
  topLevelField: "products" | "optionLists",
  catalog: ICatalog,
  variantRef: string,
): ICatalog => {
  const topLevelItems = _.cloneDeep(catalog.data[topLevelField])
  topLevelItems.forEach((topLevelItem) => {
    const items = topLevelField === "products" ? (topLevelItem as IProduct).skus : (topLevelItem as IOptionList).options
    items.forEach((item) => {
      item.priceOverrides = PriceOverrides.removeVariant(item.priceOverrides, variantRef)
    })
  })
  return updatedCatalog(catalog, { [topLevelField]: topLevelItems })
}
